export enum SmartFormConfigurationType {
    PreAnesthesiaEvaluation = 'operation/preAnesthesiaEvaluation',
    IntraAnesthesiaEvaluation = 'operation/intraAnesthesiaEvaluation',
    PostAnesthesiaEvaluation = 'operation/postAnesthesiaEvaluation',
    CheckInToOt = 'operation/checkInToOt',
    CheckInToOr = 'operation/checkInToOr',
    CheckOutFromOr = 'operation/checkOutFromOr',
    OperativeNote = 'operation/operativeNote',
}
